import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { usePlaceLevel } from './_load/PlaceLevelLoader'
import { useSavePlaceLevel } from './_requests/savePlaceLevel'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditPlaceLevelForm = () => {
  const placeLevel = usePlaceLevel()
  const [onSubmit, { loading, error }] = useSavePlaceLevel()

  const { type } = useModalData() || {}

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={placeLevel || { type }}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditPlaceLevelForm
